// buyProduct.js
'use strict';
import submitCompleteOrder from '../action/submitCompleteOrder.js';
import submitOrder from '../action/submitOrder.js';

import getMeData from '../selector/getMeData.js';
import getOperationData from '../selector/getOperationData.js';
import getOrderData from '../selector/getOrderData.js';

/**
 * Buy product.
 * @kind action
 * @param {string} {shopId} - shop id.
 * @param {string} {skuId} - sku id.
 * @param {string} {currency} - currency.
 * @param {boolean} {mustSelectPaymentSource} - requires at least one payment source.
 * @return {Promise} Action promise.
 */
const buyProduct =
  ({ shopId, skuId, currency, mustSelectPaymentSource } = {}) =>
  async (dispatch, getState) => {
    if (!skuId) {
      return dispatch({ type: '' });
    }
    const email = getMeData(getState(), 'email');
    await dispatch(
      submitOrder({
        shopId,
        productIds: [skuId],
        currency,
        email,
        mustSelectPaymentSource,
      })
    );
    const orderId = getOperationData(
      getState(),
      ['shop', shopId],
      'submitOrderId'
    );
    const sourceJointId = getOperationData(
      getState(),
      ['shop', shopId],
      'selectPaymentSourceJointId'
    );
    const source = getOrderData(getState(), orderId, 'source', sourceJointId);
    return dispatch(
      submitCompleteOrder({
        shopId,
        orderId,
        source,
        sourceJointId,
      })
    );
  };

export default buyProduct;
